module.exports = __webpack_public_path__ + "1c96f71ded3c327695236eccd6eb2253.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/simat.png
// module id = 623
// module chunks = 0